import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ShieldAlert } from 'lucide-react';
import Navbar from '../components/navbar';

const DeleteAccountDemo = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ email: '', password: '' });

  const navigateToFooter = () => {
    navigate('/#site-footer');
  };

  const handleDeleteConfirm = () => {
    window.alert('Your account has been deleted successfully.');
    navigate('/');
  };

  const canContinue = form.email.trim() && form.password.trim();

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100">
      <Navbar scrollToSection={() => {}} />

      <div className="mx-auto max-w-xl px-4 pb-10 pt-28 sm:px-6 sm:pt-32">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <div className="mb-6">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#1A87CF]">Account Center</div>
            <h1 className="mt-2 text-2xl font-bold text-slate-900">Delete Account</h1>
            <p className="mt-2 text-sm text-red-500">
              This action is permanent and cannot be undone.
            </p>
          </div>

          {step === 1 && (
            <div className="space-y-4">
              <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
                <div className="mb-2 flex items-center gap-2 font-bold">
                  <AlertTriangle size={16} />
                  Verify Your Identity
                </div>
                <p>Please enter your credentials to proceed with account deletion.</p>
              </div>

              <div>
                <label className="mb-1 block text-sm font-semibold text-slate-700">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="Enter your email"
                  className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm outline-none transition focus:border-slate-900"
                />
              </div>

              <div>
                <label className="mb-1 block text-sm font-semibold text-slate-700">Password</label>
                <input
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={onChange}
                  placeholder="Enter your password"
                  className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm outline-none transition focus:border-slate-900"
                />
              </div>

              <button
                type="button"
                disabled={!canContinue}
                onClick={() => setStep(2)}
                className="w-full rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300"
              >
                Continue to Delete Account
              </button>
            </div>
          )}

          {step === 2 && (
            <div className="space-y-4">
              <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-900">
                <div className="mb-2 flex items-center gap-2 font-bold">
                  <ShieldAlert size={16} />
                  Are You Absolutely Sure?
                </div>
                <p>
                  You are about to permanently delete your account for <span className="font-semibold">{form.email || 'this email'}</span>. This action cannot be reversed.
                </p>
              </div>

              <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
                <div className="font-semibold">Last chance to change your mind.</div>
              </div>

              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={navigateToFooter}
                  className="w-1/2 rounded-xl bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-white hover:bg-emerald-600"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleDeleteConfirm}
                  className="w-1/2 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-red-700"
                >
                  Yes, Delete Permanently
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountDemo;
